import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/creatives');

const creativesService = createService(httpClient, (client) => ({
    saveAsTemplate({ id, name, description }) {
        return client.post(`/v2/${id}/saveAsTemplate`, { name, description });
    },

    create(templateId, collectionId) {
        return client.put(`/${templateId}/creative${collectionId ? `?collectionId=${collectionId}` : ''}`);
    },
}));

export default creativesService;
